export default __webpack_public_path__ + "static/media/edit.c0d0315a.svg";